module.exports = __webpack_public_path__ + "static/perf.5773f8e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/beact/perf.jpg
// module id = 83
// module chunks = 64186320310769 88197199937824 213720915766396